import { baseApi } from './baseApi';

const borrowerApplicationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    submitApplication: builder.mutation({
      query: (body) => ({
        url: '/borrower/applications',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export default borrowerApplicationApi;
